import apiClient from './apiClient';
import { trackPromise } from 'react-promise-tracker';
import { enqueue, offlineGet } from './helpers/offlineHelpers';

export function formatLocalDateTime(date = new Date()) {
    const pad = (n) => n.toString().padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
        date.getMinutes()
    )}:${pad(date.getSeconds())}`;
}

async function getSessionUser() {
    const { data } = await trackPromise(apiClient.get('/api/user/sesion'));
    return data?.data ?? null;
}

async function listShifts(token) {
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;

    const { data } = await trackPromise(apiClient.get('/api/shift/getAll', config));
    return (data?.data ?? []).filter((shift) => shift.enabled);
}

async function supportTicketCreate(info) {
    // const { data } = await trackPromise(apiClient.post(`/api/ticket/create`, info));
    // return data ?? [];
    const payload = {
        ...info,
        createdAt: formatLocalDateTime()
    };

    if (!navigator.onLine) {
        enqueue({
            type: 'CREATE_TICKET',
            payload
        });

        return {
            success: true,
            offline: true,
            message: 'Guardado sin conexión'
        };
    }

    const { data } = await apiClient.post('/api/ticket/create', payload);
    return data;
}

async function checkPendingPreviousHour() {
    const { data } = await apiClient.get('/api/notifications/pending-previous-hour');
    return data ?? null;
}

async function getAllTickets(id, filters = {}) {
    // const { data } = await trackPromise(apiClient.post('/api/ticket/list/' + id));
    // return data.data ?? [];
    const body = {
        status: filters.status ?? null,
        machineId: filters.machineId ?? null,
        factoryId: filters.factoryId ?? null,
        departmentId: filters.departmentId ?? null,
        dateFrom: filters.dateFrom ?? null,
        dateTo: filters.dateTo ?? null
    };
    return offlineGet(
        `tickets_${id}`, // 🔥 clave dinámica por usuario/planta/etc
        () => trackPromise(apiClient.post('/api/ticket/list/' + id, body)),
        (response) => response?.data?.data ?? []
    );
}

const operatorService = {
    getSessionUser,
    listShifts,
    supportTicketCreate,
    checkPendingPreviousHour,
    getAllTickets
};

export default operatorService;
